module.exports = __webpack_public_path__ + "img/D201602_3.4071f8b2.gif";